import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { CustomerClassification } from '../../../interfaces/CustomerInterface/CustomerInterface';

interface CustomerClassificationData {
  data: CustomerClassification | null;
}

const initialState: CustomerClassificationData = {
  data: null,
};

export const customerClassificationSlice = createSlice({
  name: 'classification',
  initialState,
  reducers: {
    saveCustomerClassification: (state, action: PayloadAction<CustomerClassification>) => {
      state.data = action.payload;
    },
  },
});

export const { saveCustomerClassification } = customerClassificationSlice.actions;

export default customerClassificationSlice.reducer;
